<template>
  <form @submit.prevent="onSearch" class="mt-3 mb-3">
    <div class="row ">
      <div class="col-lg-4 col-md-6 col-sm-12">
        <div v-if="clientDropdown && clientDropdown.length">
          <SelectVue
              v-model="filters.clientId"
              :options="clientDropdown"
              :is-clear="true"
              placeholder="Kostenträger"
          />
        </div>
      </div>
      <div class="col-lg-4 col-md-6 col-sm-12">
        <div v-if="officeDropdown && officeDropdown.length">
          <SelectVue
              v-model="filters.officeId"
              :options="officeDropdown"
              :is-clear="true"
              placeholder="Standort"/>
        </div>
      </div>
      <div class="col-lg-2 col-md-6 col-sm-12">
        <Datepicker
            v-model="filters.startDate"
            position="down"/>
      </div>
      <div class="col-lg-2 col-md-6 col-sm-12">
        <Datepicker
            v-model="filters.endDate"
            position="down"/>
      </div>

      <div class="col-lg-4 col-md-6 col-sm-12">
        <div v-if="operationTypeDropdown && operationTypeDropdown.length">
          <SelectVue
              v-model="filters.operationType"
              :options="operationTypeDropdown"
              :is-clear="false"/>
        </div>
      </div>
      <div class="col-lg-4 col-md-6 col-sm-12">
        <BaseCheckbox
            :disabled="filters.operationType === 'sociotherapie_primary'"
            v-model="filters.signed"
            :labelPosition="'right'"
            label="Unterschriftspflichtig"/>
      </div>
      <div class="col-2"></div>

      <div class="col-lg-2 col-sm-12 col-12">
        <SearchButton
            type="submit"
            :label="$t('general.button.search')"
            :loading="loading"/>
      </div>
    </div>
  </form>
</template>

<script setup>
import BaseCheckbox from '@/components/base/BaseCheckbox.vue';
import Datepicker from '@/components/picker/Datepicker.vue';
import SelectVue from '@/components/SelectVue.vue';
import { defineEmits, defineProps, toRefs, watch } from 'vue';
import SearchButton from "@/components/button/SearchButton.vue";

// Reactive filters
const props = defineProps({
  filters: {
    type: Object,
    required: true,
  },
  officeDropdown: {
    type: Array,
    required: true,
  },
  clientDropdown: {
    type: Array,
    required: true,
  },
  operationTypeDropdown: {
    type: Array,
    required: true,
  },
  loading: {
    type: Boolean,
    default: false,
  },
});

// Use toRefs to maintain reactivity
const { filters }           = toRefs(props);
const officeDropdown        = toRefs(props)[ 'officeDropdown' ];
const clientDropdown        = toRefs(props)[ 'clientDropdown' ];
const operationTypeDropdown = toRefs(props)[ 'operationTypeDropdown' ];
const emit                  = defineEmits([ 'search' ]);

watch(() => filters.value.operationType, (newOperationType) => {
  if (newOperationType === 'sociotherapie_primary') {
    filters.value.signed = true;
  } else {
    filters.value.signed = false;
  }
});

function onSearch() {
  emit('search', filters.value);
}

</script>

<style scoped>
/* Add any custom styles for your search component */
</style>
